import styled from "styled-components";

import { Box, FlexDiv } from "@/components/Atoms/Box";
import SVGSprite from "@/components/Atoms/SVGSprite";
import Button from "@/components/Atoms/Button";

import Typography from "@/components/Typography";
import theme from "@/foundation/Theme";

export const CallbackSuccessWrapper = styled(FlexDiv)`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 350px;
  margin: 0 auto 16px;
`;

export const RotateCheck = styled(SVGSprite)`
  height: 86px;
  width: 86px;
  margin-bottom: 16px;
`;

export const Title = styled(Typography)`
  text-align: center;
  color: ${theme.colorsV2.blueGray.shade_800};
  font-family: var(--dm-sans);
  font-weight: 700;
  font-size: 24px;
  line-height: 31px;
  margin-bottom: 16px;
`;

export const Description = styled(Typography)`
  text-align: center;
  color: ${theme.colorsV2.blueGray.shade_800};
  font-family: var(--dm-sans);
  font-weight: 400;
  font-size: 18px;
  line-height: 23px;
  margin-bottom: 32px;
`;

export const ActionButton = styled(Button)`
  height: 60px;
  background: linear-gradient(45deg, #6941c6 0%, #7f56d9 100%);
  padding: 19.5px 45px;
  p {
    font-family: var(--dm-sans);
    font-weight: 500;
    font-size: 16px;
    line-height: 21px;
  }
`;

export const SecondaryCTAWrapper = styled(Box)`
  margin-top: 32px;
  p {
    font-family: var(--dm-sans);
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #282828;
    text-align: center;
    a {
      color: #0000ee;
    }
  }
`;
